import { useGLTF } from "@react-three/drei";
import { useMemo } from "react";
import * as THREE from "three";

export default function truck(props) {
  const { nodes, materials } = useGLTF("/cybertruck.gltf");

  const bodyMaterial = useMemo(() => {
    materials["body.002"].roughness = 0.2;
    materials["body.002"].color = new THREE.Color("#CACCCE");
    return materials["body.002"];
  }, [materials]);

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.tires.geometry}
        material={materials["rubber.002"]}
      />
      <mesh geometry={nodes.steer.geometry} material={nodes.steer.material} />
      <mesh
        geometry={nodes.interior003.geometry}
        material={nodes.interior003.material}
      />
      <mesh geometry={nodes.interior003_1.geometry}>
        <meshBasicMaterial
          color={[1 * 50, 0.01 * 50, 0.01 * 50]}
          toneMapped={false}
        />
      </mesh>
      <mesh geometry={nodes.interior003_2.geometry} material={bodyMaterial} />
      <mesh
        geometry={nodes.interior003_3.geometry}
        material={materials.glass_crack}
      />
      <mesh
        geometry={nodes.interior003_4.geometry}
        material={materials["glassgray.002"]}
      />
      <mesh geometry={nodes.interior003_5.geometry}>
        <meshBasicMaterial color={[1.5 * 5, 3 * 5, 4 * 5]} toneMapped={false} />
      </mesh>
    </group>
  );
};

useGLTF.preload("/cybertruck.gltf");
